import { PERMISSION } from '@/constants/permission.constant';

const faqTypeList = () => import('@/views/configuration/faq-types/List.vue');
const faqTypeAdd = () => import('@/views/configuration/faq-types/Add.vue');
const faqTypeEdit = () => import('@/views/configuration/faq-types/Edit.vue');

export const faqTypeRoute = [
  {
    path: '/configuration/faq-types',
    name: 'faqType',
    component: faqTypeList,
    meta: { requiresAuth: false, permissions: [PERMISSION.FAQ_TYPE_READ] },
  },

  {
    path: '/configuration/faq-types/create',
    name: 'faq-type-create',
    component: faqTypeAdd,
    meta: { requiresAuth: false, permissions: [PERMISSION.FAQ_TYPE_CREATE] },
  },
  {
    path: '/configuration/faq-types/:id/edit',
    name: 'faq-type-edit',
    component: faqTypeEdit,
    meta: { requiresAuth: false, permissions: [PERMISSION.FAQ_TYPE_UPDATE] },
  },
];
